<!--
입금확인요청 > 일괄작업
 - 컨트롤러를 따로 사용하지 않고, 컨트롤러의 기능을 mixin 상속받음
------------------------------------
-->
<template>
    <div
        class="bg-white"
        :uk-sticky="stickyLayout"
    >
        <!-- 전체작업 -->
        <div v-show="! itemChecked" class="p-0d5rem bg-white border border-white">
            <div class="uk-flex uk-flex-between uk-flex-bottom">
                <!-- 선택된 아이템 없음 -->
                <div class="no-selected-msg">
                    {{ batch.item_checked_nothing_msg }}
                </div>

                <div class="uk-width-expand"></div>



            </div>

        </div>

        <!-- 선택작업 -->
        <div v-show="itemChecked" class="p-0d5rem bg-sky-50 border border-sky-600">
            <div class="uk-flex uk-flex-between uk-flex-middle">
                <!-- 선택개수안내 -->
                <div class="uk-position-relative w-30rem h-2rem">
                    <div class="selected-msg uk-position-absolute " v-html="itemCheckedInfo"></div>
                </div>

                <button
                    class="uk-button uk-button-small uk-button-white mr-1rem"
                    type="button"
                    :disabled="disabled"
                    v-on:click="$refs['cancel'].jobInit()"
                    title="입금확인 요청을 취소합니다."
                >
                    <i class="material-icons">cancel</i>
                    요청취소
                </button>

                <div class="uk-width-expand"></div>


            </div>
        </div>

        <!-- 출고요청 기능 -->
        <cancel
            ref="cancel"
            :batch="batch"
            :csrfToken="csrfToken"
        ></cancel>

    </div>

</template>

<script>
import checkedCountable from '../../checked-countable';
import stickiable from '../../stickable';
import searchedSelectable from '../../searched-selectable';
export default {
    mixins: [
        checkedCountable,
        stickiable,
        searchedSelectable,
    ],
    components: {
        'cancel': require('./cancel.vue').default,
    },
    props: {
        /**
         * 일괄기능 공유data (상세정의는 컨트롤러 참고)
         */
        batch: Object,

        // csrf-token
        csrfToken: String,

        // 지역ID
        regionId: Number,

        /**
         * 총괄관리자 여부
         */
        hasGeneral: {
            type: Boolean,
            default: false
        },

        /**
         * 총괄관리자 & 회원사인지 (창고제한)
         */
        onlyGeneralOrUser: {
            type: Boolean,
            default: false
        },

    },
    data: function () {
        return {
        };
    },
    computed: {
        // 작업 버튼 비활성화 여부
        disabled() {
            // 선택된 아이템없으면 비활성화
            return this.batch.checked_item_count === 0;
        },

        // 선택작업 버튼 비활성화 여부
        checkedDisabled() {
            // 선택된 아이템없으면 비활성화
            return this.batch.checked_item_count === 0;
        },

        // 스티키 레이아웃 적용여부
        stickyLayout() {
            return this.onSticky && this.itemChecked;
        },


    },
    methods: {

    }
}
</script>

<style lang="scss" scoped>

.no-selected-msg {
    color: #999;
}
</style>